// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"590":"d42024ba","654":"31d6cfe0","684":"a0cde98b","911":"6385a270"}[chunkId] + ".chunk.css";
};